import React from "react";
import { Select } from "antd";
import "react-phone-number-input/style.css"; // Remove if styling manually
import countryData from "libphonenumber-js/metadata.full.json"; // Get country codes

// Extract country codes with flags
const countryOptions = Object.entries(countryData.country_calling_codes).map(
  ([code, values]) => ({
    label: (
      <span
        style={{
          display: "flex",
          alignItems: "center",
          gap: "4px",
          fontSize: "12px",
        }}
      >
        <span
          className={`fi fi-${code.toLowerCase()}`}
          style={{ fontSize: "10px" }}
        />{" "}
        {/* Flag */}+{values[0]} {/* Country code */}
      </span>
    ),
    value: values[0], // Use calling code as value
  }),
);

const PhoneNumberInput = ({ value, onChange, disable }) => {
  const handleCountryChange = (countryCode) => {
    onChange({ ...value, countryCode });
  };

  const handlePhoneChange = (e) => {
    onChange({ ...value, phoneNumber: e.target.value });
  };

  return (
    <div className="flex gap-6  items-center">
      {/* Country Code Select */}
      <Select
        disabled={disable}
        showSearch
        placeholder="Code"
        className="w-20"
        options={countryOptions}
        value={value.countryCode}
        onChange={handleCountryChange}
        optionLabelProp="label"
        dropdownStyle={{ fontSize: "12px" }} // Adjust dropdown font size
      />

      {/* Phone Number Input */}
      <input
        type="text"
        disabled={disable}
        placeholder="Phone Number"
        className="w-56 h-10 px-3 border-b border-gray-300 outline-none focus:border-b-2"
        value={value.phoneNumber}
        onChange={handlePhoneChange}
      />
    </div>
  );
};

export default PhoneNumberInput;
